import React from 'react';

export const TeamworkGraphIcon = (): React.JSX.Element => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
		<path d="M15.1245 15.125L6.87451 6.875" stroke="#292A2E" stroke-width="2.0625" />
		<circle cx="4.81201" cy="4.8125" r="2.40625" stroke="#1868DB" stroke-width="2.0625" />
		<circle cx="4.81201" cy="17.1875" r="2.40625" stroke="#BF63F3" stroke-width="2.0625" />
		<circle cx="17.187" cy="17.1875" r="2.40625" stroke="#FCA700" stroke-width="2.0625" />
		<circle cx="17.187" cy="4.8125" r="2.40625" stroke="#6A9A23" stroke-width="2.0625" />
	</svg>
);
